import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

import { StipulationMapping } from '../../features/tasks/types'

export default combineReducers({
  byId: createByIdReducer('stipulationMapping'),
  allIds: createAllIdsReducer('stipulationMapping'),
  indexIds: createIndexIdsReducer('stipulationMapping'),
  meta: createMetaReducer('stipulationMapping'),
})

interface Meta {
  total: number
}

interface State {
  byId: Map<string, StipulationMapping>
  allIds: string[]
  indexIds: string[]
  meta: Meta
}

//Selectors

export const selectAllMappings = (state: State) => {
  return state.allIds.map((id) => state.byId[id]) || []
}

export const selectMapping = (state: State, id: string) => {
  return state.byId[id] || {}
}

export const selectMappingIndex = (state: State) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectMappingMeta = (state: State) => {
  return state.meta || {}
}
